import { render, staticRenderFns } from "./object-picker-br.vue?vue&type=template&id=38f98c20&scoped=true"
import script from "./object-picker-br.vue?vue&type=script&lang=js"
export * from "./object-picker-br.vue?vue&type=script&lang=js"
import style0 from "./object-picker-br.vue?vue&type=style&index=0&id=38f98c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f98c20",
  null
  
)

export default component.exports